
export type NicePayReturnParams = {
authResultCode?: string;
authResultMsg?: string;
tid?: string;
};
